import localDB from "./localDB";

let GLOBAL = require('./globals');

const ProductStockData = {
    async list(search) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/products-stock?name=${search}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async listByProduct(id) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/product-stock/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async stock(page, pk) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/products-stock/${pk}?page=${page}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/product-stock/update`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async move(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/product-stock/move`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/product-stock/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
};

export default ProductStockData;



// WEBPACK FOOTER //
// ./src/data/ProductStockData.js